<template>
    <v-card class="px-4 py-1 p-relative" outlined :class="statusCard !== '' ? 'border-' + statusCard : ''" rounded="lg">
        <v-container class="pt-0">
<!-- Chip -->
	        <v-layout class="p-absolute d-flex flex-row full-width ma-0 pa-0 z-4" style="top: 0; right: 0; z-index: 3;">
		        <span v-if="item['blLoteInexistente']" class="text-lote-inexistente mt-1 mx-4">
		          Novo lote
						</span>
		        <div class="status-chip-group d-flex ma-0 pa-0">
			        <v-chip class="status-chip-vazio-excedido" v-if="statusCard === 'vazio-excedido'" small>
				        <span class="status-text">Vazio excedido</span>
			        </v-chip>
			        <v-chip class="status-chip-alerta-vazio" v-else-if="statusCard === 'alerta-vazio'" small>
		            <span class="status-text">Alerta de vazio</span>
			        </v-chip>

			        <!-- Deletar	-->
			        <v-tooltip v-if="item['blLoteInexistente']" top>
				        <template v-slot:activator="{ on, attrs }">
					        <v-btn
							        v-bind="attrs"
							        v-on="on"
							        depressed
							        icon
							        x-small
							        color="#ff5252"
							        @click.native="preparaDelecao()"
							        :disabled="deleting"
							        class="mr-1 card-actions__btn delete"
					        >
						        <v-icon x-small color="white">fas fa-trash</v-icon>
					        </v-btn>
				        </template>
				        <span>Remover</span>
			        </v-tooltip>
		        </div>
	        </v-layout>

<!-- Infos -->
        <v-row class="d-flex flex-column pt-5">
            <span class="label-info">Nome</span>
            <span class="nome-produtor">{{ item.nmProdutor }}</span>
            <span style="height: 20px">
              <span class="label-info">UEP </span>
              <span class="value-info">{{ item.nrUnidadeExploracao }}</span>
              <span v-if="item['qtCapacidadeUep'] >= 0">
                  <span class="label-info ml-4">
                    Capacidade Uep
                  </span>
                  <span class="value-info ml-1">
                    {{ item['qtCapacidadeUep'] }}
                  </span>
              </span>
            </span>
        </v-row>
<!-- Vazio Sanitário -->
        <v-row class="pt-4" v-if="item['qtDiasVazio'] >= 0">
            <span class="label-info"> Vazio Sanitário
                <v-tooltip top v-if="item['blLoteFechado']" max-width="160px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon size="9px" color="grey" class="mb-2" v-bind="attrs"
                                v-on="on">fas fa-question-circle</v-icon>
                    </template>
                    <span class="tooltip">Valor referente ao período do planejamento; Este valor é uma previsão.</span>
                    </v-tooltip>
            </span>
            <span class="value-info ml-1">{{ item['qtDiasVazio'] }} dias</span>
        </v-row>
	        <v-row v-else class="my-4"><v-spacer></v-spacer></v-row>
<!-- Sexo do lote -->
        <v-row class="pt-4 d-flex flex-column">
            <span class="label-info">Gênero</span>
            <v-autocomplete color="#BDCCCA" outlined dense cache-items hide-no-data persistent-hint v-model="generoLote" :items="tiposGenero"
                            item-value="sgSexo" item-text="dsSexo" hide-details />
        </v-row>

<!-- Observação -->
        <v-row class="d-flex flex-column pt-2">
	        <span class="label-info">Observação</span>
	        <v-textarea no-resize dense outlined rows="2" counter="250" v-model="observacaoLote"
	                    @change="validarObservacaoLote()" :rules="[LIMITE_CARACTERES(250)]" />
        </v-row>

<!-- Seleção do lote -->
        <v-row class="pa-0 d-flex flex-column">
            <div class="selecionar-lote d-flex align-center ma-0 px-6" @click="blSelecionado = !blSelecionado" v-ripple>
                <v-icon color="#0CA5A2" size="19" v-show="this.blSelecionado">fas fa-check-square</v-icon>
                <v-icon color="#0CA5A2" size="19" v-show="!this.blSelecionado">far fa-square</v-icon>
                <div class="selecionar-lote-texto ml-3">Selecionar</div>
            </div>
        </v-row>
        </v-container>

		<!-- Estado card deletando		-->
			<v-fade-transition hide-on-leave>
				<v-overlay v-if="deleting" absolute>
					<v-row justify="center" align="center" class="ma-2">
						Confirmar exclusão?
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#2BC1B6" small class="white--text"
								       @click="cancelarDelecao()">
									<v-icon small>fas fa-undo</v-icon>
								</v-btn>
							</template>
							<span>Desfazer</span>
						</v-tooltip>
					</v-row>
					<v-row justify="center" align="center" class="ma-2">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn v-on="on" fab depressed color="#ff5252" small class="white--text"
								       @click="deletarLote()">
									<v-icon small>fas fa-trash</v-icon>
								</v-btn>
							</template>
							<span>Deletar</span>
						</v-tooltip>
					</v-row>
				</v-overlay>
			</v-fade-transition>
    </v-card>
</template>

<script>
import {mapMutations} from "vuex";
import {RULES} from "../../resources"

export default {
    name: "PreAlojamentoCard",
    data: () => ({
      tiposGenero: [
        {sgSexo: 'MA', dsSexo: 'Macho'},
        {sgSexo: 'FE', dsSexo: 'Fêmea'},
        {sgSexo: 'MI', dsSexo: 'Misto'}
      ],
	    deleting: false,
    }),
    computed: {
	    statusCard() {
		    if(this.item['blPreAlojado']) return 'selecionado'
		    if (this.item['qtDiasVazio'] > this.limiteDiasVazio) return 'vazio-excedido'
		    if (this.item['qtDiasVazio'] > this.alertaDiasVazio) return 'alerta-vazio'
		    return ''
	    },
	    limiteDiasVazio() {
	    	const limite = this.$store.state['tabelaConfiguracao'] ?
				    this.$store.state['tabelaConfiguracao'].find(record => record['stChave'] === 'limiteDiasVazio') :
				    null

		    if (limite) return limite['stValor']
	    	return 31
	    },
	    alertaDiasVazio() {
	    	const alerta = this.$store.state['tabelaConfiguracao'] ?
				    this.$store.state['tabelaConfiguracao'].find(record => record['stChave'] === 'alertaDiasVazio') :
				    null

		    if (alerta) return alerta['stValor']
	    	return 23
	    },
      blSelecionado: {
          get() { return this.item.blPreAlojado },
          set(sel) {
            this.mtSelecionarLoteDestinoPreAlojamento({id: this.item.id, sel: sel})
          }
      },
      generoLote: {
          get() { return this.item.sgSexoSugerido },
          set(sgSexo) {
            this.mtAlterarGeneroLoteDestinoPreAlojamento({id: this.item.id, sgSexo: sgSexo})
          }
      },
      observacaoLote: {
          get() { return this.item.dsObservacao },
          set(dsObservacao) {
          	this.mtAlterarObservacaoLoteDestinoPreAlojamento({id: this.item.id, dsObservacao: dsObservacao})
          }
      }
    },
	methods: {
		...mapMutations("planejamentoAlojamento", [
				"mtSelecionarLoteDestinoPreAlojamento",
				"mtAlterarGeneroLoteDestinoPreAlojamento",
				"mtRemoverLoteDestinoPreAlojamento",
				"mtIndexarListaLoteDestinoPreAlojamento",
				"mtChangeListaLoteDestinoAlojamento",
				"mtAlterarObservacaoLoteDestinoPreAlojamento",
		]),
		...RULES,
		preparaDelecao() {
			this.deleting = true
		},
		cancelarDelecao() {
			this.deleting = false
		},
		deletarLote() {
			this.$axios.delete('/planejamento-alojamento-lote-destino/' + this.item.idPlanejamentoAlojamentoLoteDestino)
					.then(res => {
						if (!res.data) return
						if (!res.data[0].data) return

						this.mtRemoverLoteDestinoPreAlojamento(this.item.id)
						this.mtIndexarListaLoteDestinoPreAlojamento()
						this.mtChangeListaLoteDestinoAlojamento([])
					})
					.catch(error => {
						this.$store.commit("setSnack", {type: "error", msg: error})
					})
					.finally(() => {
						this.deleting = false
					})
		},
		validarObservacaoLote() {
			if (this.observacaoLote.length > 250) this.observacaoLote = this.observacaoLote.substring(0, 250)
		},
	},
    filters: {
        sugestaoGenero(sgGenero, tiposGenero) {
            if (!sgGenero || !tiposGenero) return ''
            const findTipoGenero = tiposGenero.find((tipo) => tipo.sgSexo === sgGenero).dsSexo
            return findTipoGenero ? 'Sugerido: ' + findTipoGenero.dsSexo : ''
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">

.border-vazio-excedido {
  //border: 2px solid #FF5252;
	box-shadow: 0 0 0px 1.2px #FF5252;
}

.border-selecionado {
  //border: 1px solid #008EF0;
	box-shadow: 0 0 0px 1.3px #008EF0;
}

.border-alerta-vazio {
  //border: 2px solid #FF5252;
	box-shadow: 0 0 0px 1.2px #f5b800;
}

.selecionar-lote {
  cursor: pointer;
  user-select: none;
  background-color: #87E2D129;
  border: 1px solid #33D6AB80;
  height: 42px;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}
.selecionar-lote-texto {
  font: normal normal normal 16px/22px Roboto;
  letter-spacing: 0;
  color: #0CA5A2 !important;
  text-overflow: ellipsis;
}

.label-info {
  font: normal normal normal 12px/16px Roboto;
letter-spacing: 0;
color: #12303C99;
}
.value-info {
  font: normal normal bold 12px/16px Roboto;
letter-spacing: 0;
color: #37565C;
}
.nome-produtor {
  font: normal normal bold 15px/20px Roboto;
letter-spacing: 0;
color: #10303DCC;
}

.status-chip-vazio-excedido{
  background-color: #FFEDED !important;

  .status-text {
    font: normal normal medium 10px/13px Roboto;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #FF5252;
    opacity: 0.9;
  }
}

.status-chip-alerta-vazio{
  background-color: #fdf1cc !important;

  .status-text {
    font: normal normal medium 10px/13px Roboto;
    text-transform: capitalize;
    letter-spacing: 0;
    color: #e2a900;
    opacity: 0.9;
  }
}

.tooltip {
  text-align: left;
  font: normal 12px Roboto;
  letter-spacing: 0;
  color: #e5e8e7;
}

.text-lote-inexistente {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 4px;

  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #969696;
}

.status-chip-group {
  position: absolute;
  right: 0;
  top: 2px;
}
</style>